import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { get } from 'lodash-es';

import { getRouteBuyCredits } from 'modules/v2/routes/navigation';
import { DatabaseIcon } from 'modules/v2/common/components/SvgIcon';
import { fetchUserCredits } from 'modules/api';
import {
  usePrintCreditsBalance,
  isLedgerCreditsDisplayEnabled,
} from 'modules/v2/common/hooks/usePrintCreditsBalance';

/**
 * Header credits chip. With LEDGER_CREDITS_DISPLAY enabled it reads the DS
 * credit ledger (the same source the MOD pages use); otherwise it keeps the
 * legacy BBA /user/credits read. When the ledger read fails the number is
 * hidden rather than showing a wrong value.
 */
const CreditsChip = () => {
  const ledgerDisplay = isLedgerCreditsDisplayEnabled();

  const { data: userBookCredit } = useQuery(['getUserCredits'], fetchUserCredits, {
    enabled: !ledgerDisplay,
  });
  const { data: ledgerBalance, isError: isLedgerError } = usePrintCreditsBalance({
    enabled: ledgerDisplay,
  });

  const credits = ledgerDisplay
    ? ledgerBalance?.balance
    : get(userBookCredit, 'data.data.credits', 0);
  const showNumber = !ledgerDisplay || (!isLedgerError && credits !== undefined);

  return (
    <Link
      to={getRouteBuyCredits()}
      className="gap-2 border text-neutral-800 h-[38px] font-semibold rounded-md pl-[12px] pt-[10px] pr-[14px] pb-[10px] text-xs inline-flex min-w-[104px] hover:bg-neutral-100 hover:border-neutral-300 transition-colors cursor-pointer no-underline"
      data-testid="nav-credits-chip"
    >
      <DatabaseIcon />
      <p className="text-nowrap">{showNumber ? `${credits} credits` : 'credits'}</p>
    </Link>
  );
};

export default CreditsChip;
